import { all, put,call, takeLatest } from 'redux-saga/effects';
import * as RespostaQuestao from '~/services/RespostaQuestao';
import  * as actionType from './actionType';
import * as actions from './action';
import { getErros } from '~/store/modules/errors/action';

function* loadRespostaQuestaosWorker({ params }) {
  try {
    const response = yield call(RespostaQuestao.load, params);
    yield put(actions.getRespostaQuestaos(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({ data: error.message }));
    } else {
      yield put(getErros({ data: error.message }));
    }
  }
}


function* showRespostaQuestaoWorker({id, params}) {
  try {
    const response = yield call(RespostaQuestao.show, id, params);
    yield put(actions.getRespostaQuestao(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* updateRespostaQuestaoWorker({ resposta_questao, id}) {
  try {
    const response = yield call(RespostaQuestao.update, id, resposta_questao);
    yield put(actions.getRespostaQuestao(response));
    yield put(actions.getErros({update:true}));
    yield put(getErros({update:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* storeRespostaQuestaoWorker({resposta_questao}) {
  try {
    const response = yield call(RespostaQuestao.store, resposta_questao);
    yield put(actions.getRespostaQuestao(response));
    yield put(actions.getErros({save:true}));
    yield put(getErros({save:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* removerRespostaQuestaoWorker({id}) {
  try {
    yield call(RespostaQuestao.destroy, id);
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* watcherRespostaQuestao() {
  yield takeLatest(actionType.LOAD_RESPOSTA_QUESTAOS, loadRespostaQuestaosWorker);
  yield takeLatest(actionType.STORE_RESPOSTA_QUESTAO, storeRespostaQuestaoWorker);
  yield takeLatest(actionType.SHOW_RESPOSTA_QUESTAO, showRespostaQuestaoWorker);
  yield takeLatest(actionType.UPDATE_RESPOSTA_QUESTAO, updateRespostaQuestaoWorker);
  yield takeLatest(actionType.REMOVER_RESPOSTA_QUESTAO, removerRespostaQuestaoWorker);
}

export default function* saga() {
  yield all([watcherRespostaQuestao()]);
}
